// extracted by mini-css-extract-plugin
export default {"block":"styles_block__BZIep","block__title":"styles_block__title__hs27t","block__block":"styles_block__block__-j54n","block__toolbar":"styles_block__toolbar__BVRUn"};